(($)=>{

    "use strict"; 

	var block_classes = [];

	$('.header-buttons').find('.btn').each(function(){
		block_classes.push($(this).attr('data-type'));
	});
	$('.header-buttons').find('.btn').click(function(){
		var active_class = $(this).attr('data-type');
		if($('.'+active_class).length) {
			$('.header-buttons').find('.btn').removeClass('active');
			$(this).addClass('active');
			for ( var i = 0; i < block_classes.length; ++i) {
				var block_class = block_classes[i];
				$('.'+block_class).hide();
			}
			$('.'+active_class).show();
			$('.full').hide();
			$('.view-full').addClass('active');
		}
	});

	$('.view-full').click(function(){
		$('.header-buttons').find('.btn').removeClass('active');
		for ( var i = 0; i < block_classes.length; ++i) {
			var block_class = block_classes[i];
			$('.'+block_class).hide();
		}
		$('.full').show();
		$(this).removeClass('active');
		$('html, body').animate({scrollTop: $(".control-content").offset().top - 60 }, 500);
	});

	var type = $('#active_btn').text();

	if(type){
        $('.header-buttons').find('.btn').each(function(){
            if($(this).attr('data-type') == type ) $(this).trigger('click');
        });
	}else{
		// by default show full and hide all other.
        $('.header-buttons').find('.btn').removeClass('active');
        for ( let i = 0; i < block_classes.length; ++i) {
            $('.' + block_classes[i]).hide();
        }
        $('.full').show();
	}



	$('.others-single').not('.has-new-style').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		prevArrow: $('.control-others .nav .prev'),
		nextArrow: $('.control-others .nav .next'),
		responsive: [
			/*{
				breakpoint: 1860,
				settings: {
					slidesToShow: 3
				}
 			},*/
 			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
 			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1
				}
			}
		]
	})

	$('.others-single.has-new-style').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		prevArrow: $('.control-others .nav .prev'),
		nextArrow: $('.control-others .nav .next'),
		responsive: [
			/*{
				breakpoint: 1860,
				settings: {
					slidesToShow: 3
				}
 			},*/
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: "unslick",
			}
		]
	})

	$(window).resize(function(){
		$('.others-single.has-new-style').slick('resize');
	});


	$('.header-buttons').not('.has-new-style').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		responsive: [
 			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
 			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1
				}
			}
		]
	})

})(jQuery);